import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-list-drop-down-select',
  templateUrl: './list-drop-down-select.component.html',
  styleUrls: ['./list-drop-down-select.component.scss']
})
export class ListDropDownSelectComponent implements OnInit {

  @Input() listToDisplay: Array<unknown>;
  @Output() valueSelected: EventEmitter<unknown> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  /**
   * Triggers once clicked on list item
   * Emits value from list
   * @param value: number - index of list item
   */
  listItemSelected(value: number): void {
    const itemToReturn = this.listToDisplay[value];

    this.valueSelected.emit(itemToReturn);
  }
}
